module.exports = __webpack_public_path__ + "img/ygjc001.65aab043.jpg";